// Background configurations for photo letter compositions
// Each background can be a solid color or gradient
// Designed for NFT minting with distinct, high-quality aesthetics

export interface Background {
  id: string;
  name: string;
  type: 'solid' | 'linear' | 'radial';
  colors: string[]; // Single color for solid, multiple for gradients
  angle?: number; // For linear gradients (in degrees)
}

export const backgrounds: Background[] = [
  // Radial Gradients - Centered & Focused
  {
    id: 'radial-midnight',
    name: 'Midnight Focus',
    type: 'radial',
    colors: ['#1a1a2e', '#0f0f1e', '#000000'],
  },
  {
    id: 'radial-brown-glow',
    name: 'Brown Glow',
    type: 'radial',
    colors: ['#6a5435ff', '#3d2817'],
  },
    {
    id: 'radial-white-glow',
    name: 'White Glow',
    type: 'radial',
    colors: ['#ede9e4ff', '#918d8aff'],
  },
  {
    id: 'radial-lava',
    name: 'Hardened Lava',
    type: 'radial',
    colors: ['#4a0000', '#2a0000', '#0a0000'],
  },
  {
    id: 'radial-ocean',
    name: 'Ocean Depths',
    type: 'radial',
    colors: ['#0f2027', '#203a43', '#2c5364'],
  },
  {
    id: 'radial-cosmic',
    name: 'Cosmic',
    type: 'radial',
    colors: ['#2e1753', '#1f1746', '#0d324d'],
  },
  {
    id: 'radial-forest',
    name: 'Forest Green',
    type: 'radial',
    colors: ['#2d5a4a', '#1b4332', '#0f2b1f'],
  },
  {
    id: 'radial-charcoal',
    name: 'Charcoal',
    type: 'radial',
    colors: ['#4a4a4a', '#2d2d2d', '#0f0f0f'],
  },
];

// Get a random background
export const getRandomBackground = (): Background => {
  const randomIndex = Math.floor(Math.random() * backgrounds.length);
  return backgrounds[randomIndex];
};

// Get background by ID
export const getBackgroundById = (id: string): Background | undefined => {
  return backgrounds.find(bg => bg.id === id);
};

// Default background
export const defaultBackground = backgrounds[0]; // Pure White
